// EPIC screen help (the "?" at the top of EPIC). Plain words; keep it in step with
// the screen in tools/EpicTool.tsx.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const epicHelp: ScreenHelpContent = {
  title: 'EPIC',
  intro:
    "EPIC is today's episode: a short story about your day, built from what you actually did. You can read it, listen to it, and change the style it is told in. It never changes the facts, only the voice.",
  sections: [
    {
      heading: 'The episode card',
      body: ['At the top you see the episode number, its title and the date. Below that is the audio.'],
      items: [
        { term: 'Play / Pause', text: 'appears when the episode already has audio. Press it to listen, press again to pause.' },
        { term: 'Generate audio', text: 'appears when there is no audio yet. Press it and wait; when it is done the button turns into Play.' },
        { term: 'Speak', text: 'reads the episode out loud with your phone\'s voice. If it asks you to update the app, use Generate audio instead.' },
      ],
    },
    {
      heading: 'Transcript',
      body: ['The full text of the episode. If the episode has been edited, you see the edited version.'],
    },
    {
      heading: 'Unresolved',
      body: ['A question the day left open. It only shows up when the episode has one. Think of it as something to carry into tomorrow.'],
    },
    {
      heading: 'Skin',
      body: [
        'The same day, told in a different voice. Tap a style to have the episode rewritten in it. The highlighted one is the style in use.',
        'Styles: Chronicle, Broadcast, Briefing, Dojo Report, Ship\'s Log, Mythic, Noir, Resonance, Tribunal and Anchor.',
        'A chip is dimmed while it is being applied. Give it a moment.',
      ],
    },
    {
      heading: 'Regenerate',
      body: ['Writes a fresh episode for the same date, replacing the current one. Use it if you don\'t like how this one came out. It takes a moment, and the button says "Regenerating…" while it works.'],
    },
    {
      heading: 'Past Episodes',
      body: ['A list of earlier episodes with their title, number and date. It only appears once you have some.'],
    },
    {
      heading: 'Saving',
      body: ['Nothing to save. Skins, Regenerate and Generate audio all take effect as soon as they finish. If something fails, a red message appears instead of the episode.'],
    },
  ],
};
